<template>
<header id="basix-header" class="header">

     <div class="header-menu">
          <div class="row">
               <div class="col-sm-7">
                    <label class="mt-4">{{currentRouteName }}</label>
               </div>

               <div class="col-sm-5">
                    <div class="user-area dropdown float-right">
                         <a class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :class="{'show': isActive, '': !isActive }" @click="handleClick">
                              {{NOMBRE_USUARIO}} <p class="ml-2"></p> <img class="user-avatar rounded-circle" src="../images/admin.jpg" alt="User Avatar">
                         </a>

                         <div class="user-menu dropdown-menu" :class="{'show': isActive, '': !isActive }" @click="handleClick">
                              <a class="nav-link" href="#"><i class="fa fa- user"></i>Mi perfil</a>

                              <a class="nav-link" href="#"><i class="fa fa- user"></i>Mensajes <span class="count">13</span></a>

                              <a class="nav-link" href="#"><i class="fa fa -cog"></i>Configuraciones</a>

                              <a class="nav-link"  @click="logOut"><i class="fa fa-power -off"></i>Salir</a>
                         </div>
                    </div>

               </div>
          </div>
     </div>

</header><!-- /header -->
</template>

<script>
export default {
     name: 'basix-header',
     data() {
          return {
               isActive: false,
               isFlag: false,
               isMessage: false,
               isNotification: false,
               isSearch: false,
               nameRouter: '',
               isOpen: false,
               NOMBRE_USUARIO: '',
          }
     },
     created() {
          this.nameRouter = this.$route.name;
          console.log('Cambiar de nombre : ' + this.nameRouter)
          this.NOMBRE_USUARIO = this.$cookies.get("NOMBRE_USUARIO");
     },
     methods: {
          logOut() {
               this.$cookies.set("ID_EMPRESA", '');
               this.$cookies.set("ID_USUARIO", '');
               this.$cookies.set("NOMBRE_USUARIO", '');
               this.$router.push('/access/login')
          },
          toggle(e) {
               //this.isOpen = !this.isOpen
               e.target.parentElement.classList.toggle('close')
          },
          handleClick(e) {
               this.isActive = !this.isActive;
               // if(e.target.className == "noclass"){
               //     e.target.className = "link active";
               // } else{
               //     e.target.className = "noclass";
               // }
          },
          searchClick(e) {
               this.isSearch = !this.isSearch;
          },
          handleMessage(e) {
               this.isMessage = !this.isMessage;
          },
          handleNotification(e) {
               this.isNotification = !this.isNotification;
          },
          handleFlag(e) {
               this.isFlag = !this.isFlag;
          }

     },
     computed: {
          currentRouteName() {
               console.log(this.$route)
               var str = "Visit Microsoft!";
               var res = str.replace("Microsoft", "W3Schools");
               let test = this.$route.path;
               test = test.replace("///g", "-");
               return test;
          }
     }
}
</script>

<style>
header .form-inline .search-form button {
     cursor: pointer;
}
</style>
